import RobotDead from '@/assets/images/svg/robot-dead.svg';
import RobotHappy from '@/assets/images/svg/robot-happy.svg';
import RobotSad from '@/assets/images/svg/robot-sad.svg';

export const loadingMessages = [
  {
    iconUrl: RobotHappy,
    message:
      'A Galena usa inteligência artificial para mapear suas habilidades e gerar recomendações para o seu desenvolvimento...',
    title: 'Mapeando novas habilidades...',
  },
  {
    iconUrl: RobotHappy,
    message:
      'Dica: você pode escolher dentre as habilidades mapeadas e ter recomendações específicas.',
    title: 'Mapeando novas habilidades...',
  },
  {
    iconUrl: RobotHappy,
    message:
      'Dica: quanto mais informações você inserir na plataforma, melhor serão as recomendações.',
    title: 'Mapeando novas habilidades...',
  },
  {
    iconUrl: RobotSad,
    message:
      'Recarregue a página para tentar gerar suas habilidades personalizadas novamente.',
    title: 'Algo deu errado por aqui',
  },
  {
    iconUrl: RobotDead,
    message:
      'Infelizmente não conseguimos gerar as habilidades com as informações fornecidas. Tente novamente editando o conteúdo, ou cancele, mantendo o mesmo feedback.',
    title: 'Não foi possível gerar novas habilidades',
  },
];
